import requisicaoSegura from '@/auth/requisicaoSegura';
import {
  APIResponseAvaliarFicha,
  APIResponseCurtirResenha,
  APIResponseListagemTipoDenunciaResenha,
  APIResponseReportarResenha,
  ArgumentosAvaliarFicha,
  ArgumentosReportarResenha,
} from './types/resenha';

export async function curtirResenhaUsuario(
  usuarioTituloID: string,
  curtir: boolean,
): Promise<APIResponseCurtirResenha> {
  const responseCurtirResenha: APIResponseCurtirResenha =
    await requisicaoSegura({
      endpoint: '/Usuario/ChipparResenha',
      dataForm: {
        usuarioTituloID,
        chippar: curtir,
      },
    });

  return responseCurtirResenha;
}

export async function reportarResenhaUsuario(
  props: ArgumentosReportarResenha,
): Promise<APIResponseReportarResenha> {
  const responseReportarResenha: APIResponseReportarResenha =
    await requisicaoSegura({
      endpoint: '/Usuario/ReportarResenha',
      dataForm: props,
    });

  return responseReportarResenha;
}

export async function listarTiposDenunciaResenha(): Promise<APIResponseListagemTipoDenunciaResenha> {
  const responseReportarResenha: APIResponseListagemTipoDenunciaResenha =
    await requisicaoSegura({
      endpoint: '/TipoReportarResenha/Listar',
      dataForm: {
        pagina: 0,
        paginacao: -1,
      },
    });

  return responseReportarResenha;
}

export async function avaliarFicha(
  props: ArgumentosAvaliarFicha,
): Promise<APIResponseAvaliarFicha> {
  const { fichaID, avaliacao, ...rest } = props;

  const responseAvaliarFicha: APIResponseAvaliarFicha = await requisicaoSegura({
    endpoint: '/Usuario/AvaliarTitulo',
    dataForm: {
      tituloID: fichaID,
      avaliacao: `${avaliacao}`.replace('.', ','),
      ...rest,
    },
  });

  return responseAvaliarFicha;
}
